import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { Observable, Subject } from "rxjs";
import { switchMap, takeUntil, tap } from "rxjs/operators";
import { AddSkuDialogComponent } from "src/app/components/dialogs/add-sku-dialog/add-sku-dialog.component";
import { ShipyardService } from "../shipyard.service";
import { ShipmentSku } from "../../../models/shipyard.model";
import { HeaderService } from "../../../components/header/header.service";
import {SnackbarComponent} from '../../../components/snackbar/snackbar.component';

@Component({
  selector: "app-search-add-plan-shipment-sku",
  templateUrl: "./search-add-plan-shipment-sku.component.html",
  styleUrls: ["./search-add-plan-shipment-sku.component.scss"],
})
export class SearchAddPlanShipmentSkuComponent implements OnInit, OnDestroy {
  addNewSku: boolean = false;
  account;
  @Input() data: any;
  @Input() selectedSKUs: ShipmentSku[] = [];
  @Input() selectedFbaType;
  @Input() page;
  @Input() formvalue: FormControl;
  @Input() isCaseQty: boolean = false;
  @Output() itemSelectedEvent: EventEmitter<any> = new EventEmitter();
  @Output() loadSkus: EventEmitter<any> = new EventEmitter();
  @ViewChild('warehouseName') warehouseName:ElementRef;
  skuForm: FormGroup = new FormGroup({
    skuAutocomplete: new FormControl(),
    skuQty: new FormControl(1),
  });
  filteredOptions$: Observable<any>;
  disabled: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private shipyardService: ShipyardService,
    private headerService: HeaderService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    this.data.length == 0 ? this.addNewSku =true : this.addNewSku=false;
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e));
    this.filteredOptions$ = this.skuForm
      .get("skuAutocomplete")
      .valueChanges.pipe(
        switchMap((value) =>
          this.shipyardService.TypeaheadSku(this.account, value,'',null,true)
        )
    );
    

    if (this.page === 'createOrder') {
      this.skuForm.addControl('price', new FormControl(''));
    }
  }

  ngOnChanges(changes: any): void {
    if(changes.selectedFbaType?.currentValue){
      this.addNewSku = false;
    }
  }

  displayWith(value: ShipmentSku) {
    if (value) {
      return value.sku;
    }
  }

  verifyAndLoadSku() {
    this.disabled=true;
    this.selectedSKUs
    const data = {
      skuQtyList: [
        {
          sku: this.skuForm.value.skuAutocomplete.sku ? this.skuForm.value.skuAutocomplete.sku : this.skuForm.value.skuAutocomplete,
          qty: this.skuForm.value.skuQty,
        },
      ],
      account: this?.account[0],
    };
    this.shipyardService.ValidateBulkSkus(data).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res && res.validSkus && res.validSkus.length > 0) {
         const type = this.data.length != 0 ? this.data[0].sku.FbaType : this.selectedFbaType;
            this.loadSku(res.validSkus[0]);
      } else {
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Invalid SKUs, please try again',
                action: 'Dismiss',
                  type: 'error',
              },
            }
        );
      }
      this.disabled=false;
    });
  }

  loadSku(value?) {
    let sku;
    if (this.skuForm.value.skuAutocomplete){
      if (!this.skuForm.value.skuAutocomplete.sku)
        this.skuForm.value.skuAutocomplete = value;
       sku = {
        sku: {
          Image: this.skuForm.value.skuAutocomplete.imageUrl,
          Title: this.skuForm.value.skuAutocomplete.title,
          Sku: this.skuForm.value.skuAutocomplete.sku,
          Asin: this.skuForm.value.skuAutocomplete.asin,
          FnSku: this.skuForm.value.skuAutocomplete.fnSku ? this.skuForm.value.skuAutocomplete.fnSku : value?.fnsku,
          Account: this.skuForm.value.skuAutocomplete.account,
          AccountSkuId: this.skuForm.value.skuAutocomplete.accountSkuId,
          Prep: value.prep,
          FbaType: this.skuForm.value.skuAutocomplete.fbaType ? this.skuForm.value.skuAutocomplete.fbaType : value.fbaType,
          AccountType: value.accountType,
         },
        qty: this.skuForm.value.skuQty,
      };
      if (this.skuForm.value.price) {
        sku.price = this.skuForm.value.price;
      }
      this.itemSelectedEvent.emit(sku);    
   } else {
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: 'Invalid SKUs, please try again',
              action: 'Dismiss',
                type: 'error',
            },
          }
      );
    }
    this.skuForm.reset();
    this.skuForm.get("skuQty").setValue(1);
    const price = this.skuForm.get("skuQty");
    if (price) {
      price.setValue(0);
    }
    this.addNewSku = false;
  }
  importBulk() {
    this.dialog
      .open(AddSkuDialogComponent, {
        width: "720px",
        data: {
          importBulk: true,
          isCreateShipment: true,
          shipmentTypeId: this.formvalue.get("ShipmentType"),
          selectedSKUs: this.selectedSKUs,
          selectedFbaType: this.data.length != 0 ? this.data[0].sku.FbaType : this.selectedFbaType,
          isCaseQty: this.isCaseQty
        },
      })
      .afterClosed()
      .subscribe((e: any) => {
          this.selectedSKUs=e;    
          if(this.selectedSKUs) this.loadSkus.emit(this.selectedSKUs);
    });
  }

  restrictToNumbers(event){
    if(Number(event.target.value) < 1){
      this.disabled = true;   
     } else{
      this.disabled = false;
     }
  }

  showAddNewSku(){
    this.addNewSku = true;
    this.skuForm.controls["skuQty"].setValue(1);
    setTimeout(() => this.warehouseName.nativeElement.focus());
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
